import { Badge } from '@shopify/polaris'

import { getPermissionTone, permissionLabels } from '../utils/avatarUtils'

interface PermissionBadgeProps {
  permission: string
}

export default function PermissionBadge({ permission }: PermissionBadgeProps) {
  const tone = getPermissionTone(permission)
  const label = permissionLabels[permission] || permission

  return <Badge tone={tone}>{label}</Badge>
}
